import axios from 'axios';

export default async function deleteMenu({ accessToken, menuId, setTokenLikeExpired }) {
  try {
    const requestOptions = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    console.log(`${process.env.REACT_APP_MENUS_API_URL}/${menuId}`);

    const { data } = await axios.delete(
      `${process.env.REACT_APP_MENUS_API_URL}/${menuId}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) return setTokenLikeExpired();
    console.log(err);
    return null;
  }
}
